export function GestionCarteraSkeletonFilters() {
  return (
    <section className="rounded-xl border-t-4 border-slate-300 bg-white p-6 shadow-lg">
      <div className="grid grid-cols-1 gap-4 lg:grid-cols-[minmax(260px,1fr)_minmax(220px,280px)_10rem_10rem]">
        {Array.from({ length: 2 }).map((_, index) => (
          <div key={index}>
            <div className="mb-2 h-4 w-32 animate-pulse rounded bg-slate-200" />
            <div className="h-12 w-full animate-pulse rounded-2xl bg-slate-200" />
          </div>
        ))}
        <div className="h-12 w-full animate-pulse rounded-full bg-slate-300 lg:mt-6" />
        <div className="h-12 w-full animate-pulse rounded-full bg-slate-200 lg:mt-6" />
      </div>
    </section>
  );
}

export function GestionCarteraSkeletonBulkPanel() {
  return (
    <section className="rounded-xl border-t-4 border-slate-300 bg-white p-5 shadow-lg">
      <div className="space-y-4">
        <div>
          <div className="mb-2 h-3 w-36 animate-pulse rounded bg-slate-200" />
          <div className="mb-2 h-6 w-56 animate-pulse rounded bg-slate-300" />
          <div className="h-4 w-80 max-w-full animate-pulse rounded bg-slate-200" />
        </div>
        <div className="grid grid-cols-1 items-start gap-3 lg:grid-cols-[minmax(220px,320px)_10rem_10rem]">
          <div>
            <div className="mb-2 h-4 w-32 animate-pulse rounded bg-slate-200" />
            <div className="h-12 w-full animate-pulse rounded-2xl bg-slate-200" />
          </div>
          <div className="h-12 w-full animate-pulse rounded-full bg-slate-300 lg:mt-7" />
          <div className="h-12 w-full animate-pulse rounded-full bg-slate-200 lg:mt-7" />
        </div>
      </div>
    </section>
  );
}

export function GestionCarteraSkeletonTable() {
  return (
    <section className="rounded-xl border-t-4 border-slate-300 bg-white shadow-lg">
      <div className="overflow-x-auto">
        <table className="min-w-full text-sm">
          <thead>
            <tr className="border-b border-slate-200 bg-slate-50">
              {Array.from({ length: 9 }).map((_, index) => (
                <th key={index} className="px-3 py-4 text-center">
                  <div className="mx-auto h-4 w-16 animate-pulse rounded bg-slate-200" />
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {Array.from({ length: 8 }).map((_, rowIndex) => (
              <tr key={rowIndex} className="border-b border-slate-200 last:border-b-0">
                {Array.from({ length: 9 }).map((_, colIndex) => (
                  <td key={colIndex} className="px-3 py-3 text-center">
                    <div
                      className={[
                        'mx-auto h-4 animate-pulse rounded bg-slate-200',
                        colIndex === 2 || colIndex === 3 ? 'w-36' : 'w-20',
                      ].join(' ')}
                    />
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div className="p-4">
        <div className="mx-auto h-1 w-32 overflow-hidden rounded bg-slate-200">
          <div className="h-full animate-pulse bg-slate-300" />
        </div>
      </div>
    </section>
  );
}